function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5F62\\u72C0",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11,12.4285714 L11,19.5714286 C11,20.3592855 11.6407143,21 12.4285714,21 L19.5714286,21 C20.3592855,21 21,20.3592855 21,19.5714286 L21,12.4285714 C21,11.6407143 20.3592855,11 19.5714286,11 L12.4285714,11 C11.6407143,11 11,11.6407143 11,12.4285714 Z",
  id: "basic-/-checkbox",
  fill: "#E89A4F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "basic-/-checkbox"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "basic-/-checkbox-(Background/Mask)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5,7 L5,17 C5,18.1029997 5.89699996,19 7,19 L17,19 C18.1029997,19 19,18.1029997 19,17 L19,7 C19,5.89699996 18.1029997,5 17,5 L7,5 C5.89699996,5 5,5.89699996 5,7 Z M7,7 L17,7 L17.0020008,17 L7,17 L7,7 Z",
  fill: "#282C34",
  mask: "url(#mask-2)"
})));

function SvgSidebarShapeB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72C0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarShapeB);
export default __webpack_public_path__ + "static/media/sidebar_shape-b.4fc95591.svg";
export { ForwardRef as ReactComponent };